export default __webpack_public_path__ + "static/media/heat_pump.097bbd6f.png";